import React, { useEffect, useRef, useState } from 'react';
import { AUITableCheckbox } from '@ancert/aui-table';

import {
  AUIActionBar,
  AUIActionBarSelectedsWrapper,
  AUIActionBarSelecteds,
  AUIActionBarSection,
  AUIActionBarButton,
  AUIActionBarSectionWrapper,
} from '@ancert/aui-action-bar';
import {
  AUICalendarFilter,
  AUIClearFilter,
  AUIFilterBar,
  AUIMultiselectFilter,
  AUISearchFilter,
  AUISelectFilter,
  AUIWrapperFilter,
} from '@ancert/aui-filter-bar';
import { SEARCH_OPTIONS, ESTADO_OPTIONS, generarFiltros, filtrarListado } from './filter';
import { getUserById, getUsers } from '../../../services/user.service';
import usuariosColumns from './columns';
import ModalEliminarUsuario from './ModalEliminarUsuario';
import ModalUsuario from './ModalUsuario';
import { ROL_OPTIONS } from '../../../constants/user.constants';
import { ROL } from '../../../lib/role.enum';
import { getComplaintsAssigned } from '../../../services/denuncias.service';
import { PAGE_SIZE } from '../../../config';

const GestionUsuarios = () => {
  const filterRef = useRef(null);
  const tableRef = useRef(null);
  const [listadoUsuarios, setListadoUsuarios] = useState([]);
  const [editData, setEditData] = useState(null);
  const [complaintsAssigned, setComplaintsAssigned] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [modalNuevoUsuario, setModalNuevoUsuario] = useState(false);
  const [idsUsuariosEliminar, setIdsUsuariosEliminar] = useState(null);
  const [filtros, setFiltros] = useState(null);
  const dataFiltered = filtrarListado({ listadoUsuarios, filtros });

  const verDetalleUsuario = async (id) => {
    const { status: statusUser, data: user } = await getUserById(id);
    const data = { ...user };
    data.creationDate = new Date(user.creationDate);

    if (statusUser === 200) {
      const { status: statusComplaints, data: complaints } = await getComplaintsAssigned({ idAuthority: id });
      if (statusComplaints === 200) {
        setEditData(data);
        setComplaintsAssigned(complaints);
        setModalNuevoUsuario(true);
      }
    }
  };

  const onSubmit = ({ buscador, fecha, estado, roles }) => {
    const filtrosGenerados = generarFiltros({ buscador, fecha, estado, roles });
    setFiltros(filtrosGenerados);
    tableRef.current.resetPagination();
  };

  const getListaUsuarios = async () => {
    const response = await getUsers();
    let filteredUsers = [...response.data];
    filteredUsers = filteredUsers.filter((user) => [ROL.AUTORIDAD, ROL.RESPONSABLE].includes(user.role));
    if (response?.status === 200) {
      setListadoUsuarios(filteredUsers);
    } else {
      setListadoUsuarios([]);
    }
  };

  const resetSelected = () => {
    setSelectedRows([]);
    filterRef.current.resetAUIFilterBar();
    tableRef.current.resetPagination();
    setFiltros(null);
  };

  const closeUsuarioModal = () => {
    setModalNuevoUsuario(false);
    setEditData(null);
  };

  useEffect(() => {
    getListaUsuarios();
  }, []);

  return (
    <div>
      <h1>Gestión de usuarios</h1>
      <AUIFilterBar onSubmit={onSubmit} onReset={() => setFiltros(null)} tagBar ref={filterRef}>
        <AUIWrapperFilter position="left">
          <AUISearchFilter name="buscador" options={SEARCH_OPTIONS} />
        </AUIWrapperFilter>
        <AUIWrapperFilter position="center">
          <AUICalendarFilter name="fecha" label="Fecha creación" selectionMode="range" />
          <AUISelectFilter label="Estado" name="estado" options={ESTADO_OPTIONS} />
          <AUIMultiselectFilter
            label="Rol"
            name="roles"
            options={ROL_OPTIONS.filter((rol) => rol.value !== ROL.ADMINISTRADOR)}
          />
        </AUIWrapperFilter>
        <AUIWrapperFilter position="right">
          <AUIClearFilter label="Reiniciar filtros" />
        </AUIWrapperFilter>
      </AUIFilterBar>
      <AUIActionBar className="u-mt-16">
        <AUIActionBarSelectedsWrapper>
          <AUIActionBarSelecteds description="seleccionados" onClick={resetSelected} value={selectedRows?.length} />
        </AUIActionBarSelectedsWrapper>
        <AUIActionBarSectionWrapper>
          <AUIActionBarSection>
            <AUIActionBarButton
              icon="binOutline"
              label="Eliminar"
              onClick={() => setIdsUsuariosEliminar(selectedRows)}
              disabled={selectedRows?.length === 0}
            />
          </AUIActionBarSection>
          <AUIActionBarSection position="right">
            <AUIActionBarButton
              icon="add"
              label="Añadir nuevo usuario"
              onClick={() => setModalNuevoUsuario(true)}
              disabled={selectedRows?.length > 0}
            />
          </AUIActionBarSection>
        </AUIActionBarSectionWrapper>
      </AUIActionBar>
      <AUITableCheckbox
        className="u-mt-16"
        columns={usuariosColumns(verDetalleUsuario)}
        data={dataFiltered}
        forcePagination
        selectedRowIds={selectedRows}
        setSelectedRows={setSelectedRows}
        pageSize={PAGE_SIZE.LISTADO_USUARIOS}
        totalData={dataFiltered?.length}
        ref={tableRef}
      />
      <ModalEliminarUsuario
        idsUsuariosEliminar={idsUsuariosEliminar}
        listadoUsuarios={listadoUsuarios}
        onClose={() => setIdsUsuariosEliminar(null)}
        reload={() => {
          getListaUsuarios();
          resetSelected();
        }}
      />
      <ModalUsuario
        show={modalNuevoUsuario}
        onClose={() => closeUsuarioModal()}
        reload={() => {
          getListaUsuarios();
          resetSelected();
        }}
        editData={editData}
        complaintsAssigned={complaintsAssigned}
      />
    </div>
  );
};

export default GestionUsuarios;
